export default {
  overrideRequest: function (axiosConfig) {

  },
  setfavorites: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  resetfavorites: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/PlayerFavorites.js